import { t } from 'i18next';
import * as yup from 'yup';

import { addressSchema } from 'addresses/schemas';
import { DefaultPricingType } from 'contacts/enums';
import { numberSchemaWithTransform } from 'core/yup';

export const contactGroupSchema = () =>
  yup.object().shape({
    name: yup.string().nullable().required(t('labelContactGroupName')),
    website: yup.string().nullable(),
    contactGrouping: yup.object().label(t('labelContactGrouping')).nullable(),
    defaultPricing: yup.string().label(t('labelDefaultPricing')).nullable().required(),
    baseMargin: numberSchemaWithTransform()
      .nullable()
      .when('defaultPricing', {
        is: DefaultPricingType.BASE_MARGIN,
        then: numberSchemaWithTransform().label(t('labelBaseMargin')).required(),
        otherwise: numberSchemaWithTransform().label(t('labelBaseMargin')).nullable(),
      }),
    baseDiscount: numberSchemaWithTransform()
      .nullable()
      .when('defaultPricing', {
        is: DefaultPricingType.BASE_DISCOUNT,
        then: numberSchemaWithTransform().label(t('labelBaseDiscount')).required(),
        otherwise: numberSchemaWithTransform().label(t('labelBaseDiscount')).nullable(),
      }),
    domains: yup
      .array()
      .label(t('labelDomains'))
      .of(yup.object({ id: yup.string(), title: yup.string() })),
    isCustomer: yup.boolean().label(t('labelIsCustomer')).nullable(),
    isVendor: yup.boolean().label(t('labelIsVendor')).nullable(),
    automatedPricing: yup.boolean().label(t('labelAutomatedPricing')).nullable(),
    autoLeadTimeEnabled: yup.boolean().label(t('labelAutoLeadTimeEnabled')).nullable(),
    showInventory: yup.boolean().label(t('labelShowInventory')).nullable(),
    freightEnabled: yup.boolean().label(t('labelFreightEnabled')).nullable(),
    defaultAddress: addressSchema(),
  });
